export default __webpack_public_path__ + "static/media/file-download.306fe68a.svg";